import React from 'react';
import styled from 'styled-components';
import SkeletonCard from './SkeletonCard';


const DashboardSkeleton = () => {
    // Generate an array of 8 items to simulate a grid
    const skeletonItems = Array.from({ length: 8 });

    return (
        <StatsGridSkeleton>
            {skeletonItems.map((_, index) => (
                <SkeletonCard key={index} />
            ))}
        </StatsGridSkeleton>
    );
};

export default DashboardSkeleton;



const StatsGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.5rem;
    padding-bottom: 1.5rem;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;
